export const sorts = {
  default: [],
  options: [
    { name: 'Title',    key: 'code',        options: [{ key: '-code',        value: 'Most' }, { key: 'code',        value: 'Least' }] },
    { name: 'Status',   key: 'status',      options: [{ key: '-status',      value: 'Most' }, { key: 'status',      value: 'Least' }] },
    { name: 'End date', key: 'ends_at',     options: [{ key: '-ends_at',     value: 'Most' }, { key: 'ends_at',     value: 'Least' }] },
    { name: 'Type',     key: 'type',        options: [{ key: '-type',        value: 'Most' }, { key: 'type', value: 'Least' }] },
    { name: 'Used',     key: 'usage_count', options: [{ key: '-usage_count', value: 'Most' }, { key: 'usage_count', value: 'Least' }] }
  ]
};
